'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var IdentityProvider = /*#__PURE__*/function () {
  function IdentityProvider() {
    _classCallCheck(this, IdentityProvider);
  }

  _createClass(IdentityProvider, [{
    key: "getId",
    value:
    /* Return id of identity (to be signed by orbit-db public key) */
    function () {
      var _getId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getId(_x) {
        return _getId.apply(this, arguments);
      }

      return getId;
    }()
    /* Return signature of OrbitDB public key signature */

  }, {
    key: "signIdentity",
    value: function () {
      var _signIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, options) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function signIdentity(_x2, _x3) {
        return _signIdentity.apply(this, arguments);
      }

      return signIdentity;
    }()
    /* Verify a signature of OrbitDB public key signature */

  }, {
    key: "type",
    get:
    /*
      Return the type for this identity-procider
      NOTE! This is the only property of the interface that
      shouldn't be overridden in the inherited IdentityProvider
    */
    function get() {
      return this.constructor.type;
    }
  }], [{
    key: "verifyIdentity",
    value: function () {
      var _verifyIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(identity) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function verifyIdentity(_x4) {
        return _verifyIdentity.apply(this, arguments);
      }

      return verifyIdentity;
    }()
    /* Return the type for this identity provider */

  }, {
    key: "type",
    get: function get() {
      throw new Error("'static get type ()' needs to be defined in the inheriting class");
    }
  }]);

  return IdentityProvider;
}();

module.exports = IdentityProvider;